import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import parse from 'html-react-parser';


class ImportantDocument extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getImportantDocument();
    };



    getImportantDocument = async()=>{
        var id = await this.props.params.id;
        if(id){
            var response = await Api.GetRequest({}, 'important-document/'+id);
            if(response.status == 200){
                this.setState({'important_document' : response.important_document});
            }
            else{
                toast.error("Something went wrong. Please try again later.");
            }
        }
        else{
            this.props.navigate(-1)
        }
       
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'important_document' : {
                'description' : "",
                'mode_of_application' : "",
                'eligibility' : "",
                'required_documents' : "",
                'web_links' : "",
                'description_height' : "",
                'eligibility_height' : "",
                'required_documents_height' : "",
                'mode_of_application_height' : "",
                'web_links_height' : ""
            }
        };
        this.description_ref = React.createRef()
        this.eligibility_ref = React.createRef()
        this.required_documents_ref = React.createRef()
        this.mode_of_application_ref = React.createRef()
        this.web_links_ref = React.createRef()
    }

    
    setDescriptionHeight = async()=>{
        var height = this.description_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'description_height' : height + "px"});
    }

    setEligibilityHeight = async()=>{
        var height = this.eligibility_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'eligibility_height' : height + "px"});
    }

    setRequiredDocumentsHeight = async()=>{
        var height = this.required_documents_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'required_documents_height' : height + "px"});
    }

    setModeOfApplicationHeight = async()=>{
        var height = this.mode_of_application_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'mode_of_application_height' : height + "px"});
    }

    setWebLinksHeight = async()=>{
        var height = this.web_links_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'web_links_height' : height + "px"});
    }


    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src={process.env.REACT_APP_SERVER + this.state.important_document.banner}/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000',"textTransform" : "uppercase"}}>{this.state.important_document.title}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="news_details_main">
                    <div class="container">
                        <div class="row" id="counter">
                            <div class="col-lg-8">
                                <div class="details_wrapper_area">
                                   
                                    <div class="details_text_wrapper text-start">
                                        
                                        <iframe  onLoad={()=>{this.setDescriptionHeight()}} scrolling="no" frameBorder="0" height={this.state.description_height} srcDoc={this.state.important_document.description} ref={this.description_ref}  style={{'width':'100%'}}/>
                                        
                                        {this.state.important_document.eligibility &&
                                            <>
                                                <h3 className="my-4">Eligibility</h3>
                                                <iframe  onLoad={()=>{this.setEligibilityHeight()}} scrolling="no" frameBorder="0" height={this.state.eligibility_height} srcDoc={this.state.important_document.eligibility} ref={this.eligibility_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                        {this.state.important_document.required_documents &&
                                            <>
                                                <h3 className="my-4">Required Documents</h3>
                                                <iframe  onLoad={()=>{this.setRequiredDocumentsHeight()}} scrolling="no" frameBorder="0" height={this.state.required_documents_height} srcDoc={this.state.important_document.required_documents} ref={this.required_documents_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                        {this.state.important_document.mode_of_application &&
                                            <>
                                                <h3 className="my-4">Mode Of Application</h3>
                                                <iframe  onLoad={()=>{this.setModeOfApplicationHeight()}} scrolling="no" frameBorder="0" height={this.state.mode_of_application_height} srcDoc={this.state.important_document.mode_of_application} ref={this.mode_of_application_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                        {this.state.important_document.web_links &&
                                            <>
                                                <h3 className="my-4">Web link</h3>
                                                <iframe  onLoad={()=>{this.setWebLinksHeight()}} scrolling="no" frameBorder="0" height={this.state.web_links_height} srcDoc={this.state.important_document.web_links} ref={this.web_links_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="sidebar_first">
                                    <div class="share_causes_wrapper sidebar_boxed">
                                        <div class="sidebar_heading_main">
                                            <h3>Share</h3>
                                        </div>
                                        <div class="social_icon_sidebar">
                                            <ul>
                                                <li><a href="#!"><img src="/assets/img/icon/facebook.png" alt="icon"/></a></li>
                                                <li><a href="#!"><img src="/assets/img/icon/instagram.png" alt="icon"/></a></li>
                                                <li><a href="#!"><img src="/assets/img/icon/twitter.png" alt="icon"/></a></li>
                                                <li><a href="#!"><img src="/assets/img/icon/linkedin.png" alt="icon"/></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(ImportantDocument)